import {Component, ViewChild} from '@angular/core';
import {NavController, NavParams, Platform, Nav} from 'ionic-angular';
import {LoginPage} from "../login/login";
import {StorageService} from "../../providers/storage";

@Component({
  selector: 'page-loader',
  templateUrl: 'loader.html'
})
export class LoaderPage {

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public storageService: StorageService,
    public platform: Platform
  ) {}

  ionViewDidLoad() {
    this.navCtrl.push(LoginPage);
  }

  ngOnInit() {}


}



// WEBPACK FOOTER //
// ./src/pages/loader/loader.ts